/*https://medium.com/@ryanchenkie_40935/angular-authentication-using-route-guards-bf7a4ca13ae3*/
//https://stackoverflow.com/a/50143721/6241324
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import * as _ from 'lodash';
import { AccessService } from 'src/app/core/services/access.service';

@Injectable({
  providedIn: 'root', // Ensures it's a singleton
})
@Injectable()
export class AuthRoleGuardService implements CanActivate {
  constructor(private auth: AccessService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    var pathSegments = _.compact(state.url.split('/'));
    var api_key =
      pathSegments[0] == 'fauxbox' && pathSegments[1].length == 32
        ? pathSegments[1]
        : pathSegments[0] == 'fauxbox' && pathSegments[2].length == 32
        ? pathSegments[2]
        : null; // for mailer
    return this.auth.checkUserAccess(api_key).pipe(
      map((response) => {
        if (response.status === 0) {
          //this.auth.me = response;
          localStorage.setItem('loginUrl', state.url);
          this.router.navigate(['/authentication/sign-in']);
          return false;
        } else {
          const expectedRoles = _.has(route, 'data.expectedRoles')
            ? route.data.expectedRoles
            : [];
          const blockedRoles = _.has(route, 'data.blockedRoles')
            ? route.data.blockedRoles
            : [];
          //this.auth.checkUserAccessOld(api_key);
          var roleCheck = _.reduce(
            expectedRoles,
            (b, role) => {
              return b || this.auth.isInGroup('user', role);
            },
            false,
          );
          var roleBlock = _.reduce(
            blockedRoles,
            (b, role) => {
              return b || this.auth.isInGroup('user', role);
            },
            false,
          );
          if (
            _.has(route.data, 'expectedRoles') &&
            roleCheck &&
            (!_.has(route.data, 'blockedRoles') || !roleBlock)
          ) {
            if (_.has(route.data, 'mobileRedirect')) {
              this.router.navigate([route.data.mobileRedirect, api_key]);
            }
            return true;
          } else if (
            (!_.has(route.data, 'expectedRoles') || roleCheck) &&
            _.has(route.data, 'blockedRoles') &&
            !roleBlock
          ) {
            if (_.has(route.data, 'mobileRedirect')) {
              this.router.navigate([route.data.mobileRedirect, api_key]);
            }
            return true;
          } else {
            this.router.navigate(['/authentication/404']);
            return false;
          }
        }
      }),
      catchError((err) => {
        localStorage.setItem('loginUrl', state.url);
        this.router.navigate(['/authentication/sign-in']);
        return of(false);
      }),
    );
  }
}
